module.exports = __webpack_public_path__ + "media/images/favicon-8a9968c5f126fe3a69a10c393239f466.ico";